<template>
  <div class="message-actions">
    <el-tooltip
      :content="t('chat.buttons.recall')"
      placement="top"
      transition="el-zoom-in-center"
    >
      <AppButton
        class="tw-bg-white tw-z-50 tw-h-7 tw-w-7 hover:tw-bg-gray-200"
        text
        circle
        data-button
        @click="clickHandler"
      >
        <AppIcon shape="redo-icon" size="25" />
      </AppButton>
    </el-tooltip>
  </div>
</template>
<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import { useConfirmWarning } from '@shared/composables/use-confirm-warning'

const { t } = useI18n()

const emit = defineEmits<{
  (event: 'recall'): void
}>()

const { confirmPositive } = useConfirmWarning()

const clickHandler = () => {
  confirmPositive({
    text: t('chat.messages.recalledConfirm'),
    title: t('common.warning'),
    onConfirm: () => emit('recall'),
  })
}
</script>

<style lang="scss" scoped>
.message-actions {
  @apply tw-hidden tw-border-1 tw-bg-white tw-border-gray-300 tw-px-1 tw-py-0.5 tw-z-50 tw-right-0.5 tw-top-[-20px] tw-absolute  tw-rounded-xs;
}
</style>
